import { render, staticRenderFns } from "./OrderPlaced.vue?vue&type=template&id=9bea0f08&scoped=true&"
import script from "./OrderPlaced.vue?vue&type=script&lang=js&"
export * from "./OrderPlaced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bea0f08",
  null
  
)

export default component.exports